import React from "react";
import { CAN_USE_CALCULATOR } from "../../constants/authorize";
import Authorize from "../Authorize";
import { CALCULATE } from "../../constants/translates";
import ClientsFeeCalculator from "../ClientsFeeCalculator";
import ModalWrapper from "./modalWrapper";

const CalculateClientSum: React.FC = () => {
  return (
    <Authorize permission={CAN_USE_CALCULATOR}>
      <ModalWrapper
        buttonCaption={CALCULATE}
        modalTitle="Rates Calculator"
        modalFooter={null}
      >
        <ClientsFeeCalculator />
      </ModalWrapper>
    </Authorize>
  );
};

export default CalculateClientSum;
